import React, { ReactElement } from "react";
import styled from "styled-components";
import responsiveStyling from "lib/responsive";
import Text, { TextType } from "components/Text";
import ComponentLoader from "components/ComponentLoader";
import CredentialsListContainer from "./CredentialsListContainer";
import {
  BrandColorPalette,
  PrimaryColorPalette,
  TextAndShapesPalette,
} from "lib/styles/colors";
import Breadcrumb from "components/Breadcrumb";
import { useRouter } from "next/router";
import { useFullCurrentUserInformation } from "core/profile/useFullCurrentUserInformation";
import { getCredentialsArrayFromUserDetails } from "../helpers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* height: 100%; */
  padding: 24px 16px;
  ${responsiveStyling({
    ">768": `
      padding: 40px;
      margin: 80px 40px;
      max-width: 985px;
    `,
  })}
`;

const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
  ${responsiveStyling({
    ">768": `
    margin-top: 32px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    `,
  })}
`;

const StyledTitleText = styled.p`
  color: ${TextAndShapesPalette.BRAND_BLACK};
  margin-top: 16px;
  font-style: normal;
  font-weight: 600;
  font-family: "Gilroy";
  font-size: 18px;
  line-height: 22px;
  ${responsiveStyling({
    ">768": `
    font-size: 24px;
    line-height: 48px;
    `,
  })}
`;

const AddCredentialButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  background: ${BrandColorPalette.BRANDING};
  cursor: pointer;
  height: 64px;
  width: 100%;
  ${responsiveStyling({
    ">768": `
      padding: 8px 16px;
      width: 240px;
    `,
  })}
`;

interface Props {
  userRefId: string;
}

export default function CredentialsHomeContainer({
  userRefId,
}: Props): ReactElement {
  const router = useRouter();
  const { isLoading, error, userDetails } = useFullCurrentUserInformation({
    userRefId,
  });
  const credentials = getCredentialsArrayFromUserDetails(userDetails);

  const handleClickGoBack = () => {
    router.push("/dashboard");
  };

  return (
    <Container>
      <Breadcrumb goBackHandler={handleClickGoBack} text="Back to Dashboard" />
      <TopRow>
        <StyledTitleText>Credentials</StyledTitleText>
        <AddCredentialButton />
      </TopRow>
      {/* Maybe refactor this the dashboard -- reusing from apply process */}
      <ComponentLoader error={error} isLoading={isLoading}>
        <CredentialsListContainer credentials={credentials} />
      </ComponentLoader>
    </Container>
  );
}

function AddCredentialButton(): ReactElement {
  const router = useRouter();

  const handleClickAdd = () => {
    router.push("/dashboard/credentials/add");
  };

  return (
    <AddCredentialButtonContainer onClick={handleClickAdd}>
      <Text type={TextType.BUTTON} fontColor={PrimaryColorPalette.MAIN_6}>
        Add Credential
      </Text>
    </AddCredentialButtonContainer>
  );
}
